import { EProfessionalApprovalStatus } from "@/domain/enums/EProfessionalApprovalStatus";
import { useCases } from "@/core";
import ProfessionalPresentationMappers from "@/presentation/mappers/ProfessionalPresentationMappers";
import ListControllerMixin from "@/utils/ListControllerMixin";

const EMPTY_STATE_LABELS = {
  [EProfessionalApprovalStatus.PENDING]: "pendente",
  [EProfessionalApprovalStatus.APPROVED]: "aprovado",
  [EProfessionalApprovalStatus.REJECTED]: "reprovado",
};

export default {
  mixins: [ListControllerMixin],
  mounted() {
    this.loadingItems = true;
    this.getData();
  },
  data() {
    return {
      EProfessionalApprovalStatus,
      filters: {
        page: 1,
        q: "",
        status: EProfessionalApprovalStatus.PENDING,
      },
      columns: [{ name: "Nome" }, { name: "Status" }],
    };
  },
  computed: {
    professionals() {
      return ProfessionalPresentationMappers.toEligibleListViewModel(
        this.items,
      );
    },
    emptyStateTitle() {
      return `Nenhum profissional ${
        EMPTY_STATE_LABELS[this.filters.status]
      } encontrado`;
    },
  },
  methods: {
    fetchPromise() {
      return useCases.listProfessionalsUseCase.execute(this.filters);
    },
    changeTab(status) {
      if (this.filters.status === status) return;
      this.$set(this.filters, "status", status);
      this.loadingItems = true;
      this.getData();
    },
  },
};
